<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-7>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Toolbar.usage") }}</h2>
          </v-flex>
        </v-layout>
        <div class="pa-5">
          <v-layout row wrap justify-center align-end mt-n4>
            <v-flex xs12 md12 lg12 pa-2>
              <v-card class="mx-auto justify-content-between" elevation="3">
                <template #progress>
                  <v-progress-linear
                    color="#077893"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <!-- <v-flex xs1 md1 lg1>
                      <v-avatar size="25" color="#077893">
                        <v-icon small dark>{{ item.icon }} </v-icon>
                      </v-avatar>
                    </v-flex> -->
                    <v-flex xs8 sm8 md8 lg8>
                      <v-avatar size="25" color="#077893">
                        <!-- <v-icon small dark>{{ item.icon }} </v-icon> -->
                        <v-icon small dark>mdi-tune-variant </v-icon>
                      </v-avatar>
                      <span
                        style="font-size: 18px"
                        class="black--text font-weight-bold"
                      >
                        <!-- {{ $t(item.title) }} -->
                        {{ $t("dashboard.total") }}
                      </span>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4 text-end>
                      <!-- <v-tooltip top color="#077893">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="#077893"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="GetDetailDashbord(HeadAll, Status.Count)"
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("consentlist.detail") }}</span>
                      </v-tooltip> -->

                      <v-chip class="ma-2 white--text" color="#077893">
                        {{ $t("dashboard.count") }}
                        <b class="ml-1 mr-1" style="font-size: 20px">
                          {{ StatusAll.toLocaleString("en") }}</b
                        >
                        {{ $t("dashboardUser.list") }}
                      </v-chip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-layout row wrap justify-center align-center mt-n5>
                  <v-flex xs11 sm11 md3 lg3>
                    <div id="chart" class="mb-2 text-center">
                      <div>
                        <center>
                          <apexchart
                            width="250"
                            type="donut"
                            :options="chartOptionsDonut"
                            :series="seriesDonutFix.map(Number)"
                          ></apexchart>
                        </center>
                        <!-- {{ data.flat() }} <br />
                        {{ seriesDonutFix }} -->
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs11 sm11 md9 lg9>
                    <v-layout row wrap justify-center align-center>
                      <v-flex xs3 lg2 text-start pl-5>
                        {{ $t("dashboardUser.statusapp") }}
                      </v-flex>
                      <v-flex xs6 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="#077893"
                            height="25"
                            :value="StatusCountApprove"
                          >
                            <b class="mr-1">{{
                              StatusCountApprove.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-center align-center pt-2>
                      <v-flex xs3 lg2 text-start pl-5>
                        {{ $t("dashboardUser.statusreject") }}
                      </v-flex>
                      <v-flex xs6 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="error"
                            height="25"
                            :value="StatusCountUnApprove"
                          >
                            <b class="mr-1">{{
                              StatusCountUnApprove.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-center align-center pt-2>
                      <v-flex xs3 lg2 text-start pl-5>
                        {{ $t("dashboardUser.statuspen") }}
                      </v-flex>
                      <v-flex xs6 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="#0AADD6"
                            height="25"
                            :value="StatusCountWait"
                          >
                            <b class="mr-1">{{
                              StatusCountWait.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-center align-center pt-2>
                      <v-flex xs3 lg2 text-start pl-5>
                        {{ $t("dashboard.expire") }}
                      </v-flex>
                      <v-flex xs6 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="#043F4E"
                            height="25"
                            :value="StatusCountExpire"
                          >
                            <b class="mr-1">{{
                              StatusCountExpire.toLocaleString("en")
                            }}</b
                            >{{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <!-- Card2 -->

            <v-flex xs12 md6 lg6 pa-2>
              <v-card class="mx-auto justify-content-between" elevation="3">
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <!-- <v-flex xs1 md1 lg1>
                      <v-avatar size="25" color="#077893">
                        <v-icon small dark>{{ item.icon }} </v-icon>
                      </v-avatar>
                    </v-flex> -->
                    <v-flex xs7 sm7 md7 lg7>
                      <v-avatar size="25" color="#077893">
                        <!-- <v-icon small dark>{{ item.icon }} </v-icon> -->
                        <v-icon small dark>mdi-vector-line </v-icon>
                      </v-avatar>
                      <span
                        style="font-size: 18px"
                        class="black--text font-weight-bold"
                      >
                        <!-- {{ $t(item.title) }} -->
                        {{ $t("consentlist.generalconsent") }}
                      </span>
                    </v-flex>
                    <v-flex xs5 sm5 md5 lg5 text-end>
                      <!-- <v-tooltip top color="#077893">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="#077893"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="
                              GetDetailDashbord(HeadGeneral, CountGeneral.Count)
                            "
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("consentlist.detail") }}</span>
                      </v-tooltip> -->
                      <v-chip class="ma-2 white--text" color="#077893">
                        {{ $t("dashboard.count") }}
                        <b class="ml-1 mr-1" style="font-size: 20px">
                          {{ CountGeneralAll.toLocaleString("en") }}</b
                        >
                        {{ $t("dashboardUser.list") }}
                      </v-chip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-layout row wrap justify-center align-center mt-n3>
                  <v-flex xs11 sm11 md3 lg3 ml-n9>
                    <div id="chart" class="mb-3 text-center">
                      <center>
                        <apexchart
                          width="235"
                          type="donut"
                          :options="chartOptionsDonut"
                          :series="seriesDonutFixGeneral.map(Number)"
                        ></apexchart>
                      </center>
                      <!-- {{ data.flat() }} <br />
                        {{ seriesDonutFix }} -->
                    </div>
                  </v-flex>
                  <v-flex xs11 sm11 md9 lg9>
                    <v-layout row wrap justify-end>
                      <v-flex xs3 lg3 text-end pr-3>
                        {{ $t("dashboardUser.statusapp") }}
                      </v-flex>
                      <v-flex xs7 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="#077893"
                            height="25"
                            :value="CountGeneralApprove"
                          >
                            <b class="mr-1">{{
                              CountGeneralApprove.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end pt-2>
                      <v-flex xs3 lg3 text-end pr-3>
                        {{ $t("dashboardUser.statusreject") }}
                      </v-flex>
                      <v-flex xs7 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="error"
                            height="25"
                            :value="CountGeneralUnApprove"
                          >
                            <b class="mr-1">{{
                              CountGeneralUnApprove.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end pt-2>
                      <v-flex xs3 lg3 text-end pr-3>
                        {{ $t("dashboardUser.statuspen") }}
                      </v-flex>
                      <v-flex xs7 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="#0AADD6"
                            height="25"
                            :value="CountGeneralWait"
                          >
                            <b class="mr-1">{{
                              CountGeneralWait.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end pt-2>
                      <v-flex xs3 lg3 text-end pr-3>
                        {{ $t("dashboard.expire") }}
                      </v-flex>
                      <v-flex xs7 lg7>
                        <div>
                          <v-progress-linear
                            color="#043F4E"
                            height="25"
                            :value="CountGeneralExpire"
                          >
                            <strong class="mr-1">{{
                              CountGeneralExpire.toLocaleString("en")
                            }}</strong>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <!-- Card3 -->

            <v-flex xs12 sm12 md6 lg6 pa-2>
              <v-card class="mx-auto justify-content-between" elevation="3">
                <v-card-text>
                  <v-layout row wrap justify-center align-center>
                    <!-- <v-flex xs1 md1 lg1>
                      <v-avatar size="25" color="#077893">
                        <v-icon small dark>{{ item.icon }} </v-icon>
                      </v-avatar>
                    </v-flex> -->
                    <v-flex xs7 sm7 md7 lg7>
                      <v-avatar size="25" color="#077893">
                        <!-- <v-icon small dark>{{ item.icon }} </v-icon> -->
                        <v-icon small dark>mdi-vector-square </v-icon>
                      </v-avatar>
                      <span
                        style="font-size: 18px"
                        class="black--text font-weight-bold"
                      >
                        <!-- {{ $t(item.title) }} -->
                        {{ $t("consentlist.groupconsent") }}
                      </span>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs5 sm5 md5 lg5 text-end>
                      <!-- <v-tooltip top color="#077893">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            color="#077893"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            @click="
                              GetDetailDashbord(HeadGroup, CountGroup.Count)
                            "
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("consentlist.detail") }}</span>
                      </v-tooltip> -->
                      <v-chip class="ma-2 white--text" color="#077893">
                        {{ $t("dashboard.count") }}
                        <b class="ml-1 mr-1" style="font-size: 20px">
                          {{ CountGroupAll.toLocaleString("en") }}</b
                        >
                        {{ $t("dashboardUser.list") }}
                      </v-chip>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-layout row wrap justify-center align-center mt-n3>
                  <v-flex xs11 sm11 md3 lg3 ml-n9>
                    <div id="chart" class="mb-3 text-center">
                      <div>
                        <center>
                          <apexchart
                            width="235"
                            type="donut"
                            :options="chartOptionsDonut"
                            :series="seriesDonutFixGroup.map(Number)"
                          ></apexchart>
                        </center>
                        <!-- {{ data.flat() }} <br />
                        {{ seriesDonutFix }} -->
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs11 lg9>
                    <v-layout row wrap justify-end>
                      <v-flex xs3 lg3 text-end pr-3>
                        {{ $t("dashboardUser.statusapp") }}
                      </v-flex>
                      <v-flex xs7 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="#077893"
                            height="25"
                            :value="CountGroupApprove"
                          >
                            <b class="mr-1">{{
                              CountGroupApprove.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end pt-2>
                      <v-flex xs3 lg3 text-end pr-3>
                        {{ $t("dashboardUser.statusreject") }}
                      </v-flex>
                      <v-flex xs7 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="error"
                            height="25"
                            :value="CountGroupUnApprove"
                          >
                            <b class="mr-1">{{
                              CountGroupUnApprove.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end pt-2>
                      <v-flex xs3 lg3 text-end pr-3>
                        {{ $t("dashboardUser.statuspen") }}
                      </v-flex>
                      <v-flex xs7 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="#0AADD6"
                            height="25"
                            :value="CountGroupWait"
                          >
                            <b class="mr-1">
                              {{ CountGroupWait.toLocaleString("en") }}</b
                            >
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-end pt-2>
                      <v-flex xs3 lg3 text-end pr-3>
                        {{ $t("dashboard.expire") }}
                      </v-flex>
                      <v-flex xs7 lg7 text-center>
                        <div>
                          <v-progress-linear
                            color="#043F4E"
                            height="25"
                            :value="CountGroupExpire"
                          >
                            <b class="mr-1">{{
                              CountGroupExpire.toLocaleString("en")
                            }}</b>
                            {{ $t("dashboardUser.list") }}
                          </v-progress-linear>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <!-- CardSourceSystem -->

            <v-flex xs12 md12 lg12 pa-2>
              <v-card class="mx-auto justify-content-between" elevation="3">
                <v-layout row wrap justify-space-between align-start>
                  <v-flex xs12 md12 lg7 pa-2>
                    <v-card-title primary-title class="pa-4">
                      <v-layout row wrap justify-space-between align-center>
                        <v-flex xs12 lg6>
                          <v-avatar size="25" color="#077893">
                            <v-icon small dark>mdi-signal-cellular-1 </v-icon>
                          </v-avatar>
                          <span
                            style="font-size: 18px"
                            class="font-weight-bold"
                          >
                            {{ $t("dashboard.permonth") }}
                          </span>
                        </v-flex>
                        <v-flex xs12 lg3> </v-flex>
                        <v-flex xs12 lg3>
                          <v-select
                            color="#077893"
                            outlined
                            dense
                            hide-details
                            v-model="NumMonth"
                            :items="$t('dashboard.CountMonth')"
                            @change="Fn_SelectCountMonth(NumMonth)"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-card-title>
                    <v-layout row wrap justify-center align-center mt-15>
                      <v-flex xs12 lg12>
                        <v-card elevation="0">
                          <v-card-text>
                            <center>
                              <apexchart
                                v-if="$t('default') === 'th'"
                                class="pa-5"
                                type="bar"
                                height="500"
                                :options="options"
                                :series="series"
                              >
                              </apexchart>
                              <apexchart
                                v-else
                                class="pa-5"
                                type="bar"
                                height="500"
                                :options="optionsEng"
                                :series="series"
                              >
                              </apexchart>
                            </center>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-divider vertical></v-divider>
                  <v-flex xs12 lg5>
                    <v-container v-for="item in SourceSystem" :key="item.title">
                      <v-layout row wrap>
                        <v-flex xs10 md10 lg10>
                          <v-avatar size="25" color="#077893">
                            <v-icon small dark>{{ item.icon }} </v-icon>
                          </v-avatar>
                          <span
                            style="font-size: 18px"
                            class="black--text font-weight-bold"
                          >
                            {{ $t(item.title) }}
                          </span>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs1 md1 lg1 text-end>
                          <!-- <v-tooltip left color="#077893">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :disabled="item.num == 0"
                                icon
                                color="#077893"
                                v-bind="attrs"
                                v-on="on"
                                @click="GetDetailDashbord(item.title, item.num)"
                              >
                                <v-icon>mdi-text-box-search</v-icon>
                              </v-btn>
                            </template>
                            <span
                              >{{ $t("consentlist.detail") }}
                              {{ $t(item.title) }}</span
                            >
                          </v-tooltip> -->
                        </v-flex>
                      </v-layout>
                      <v-progress-linear
                        striped
                        color="#077893"
                        :value="item.num"
                        height="30"
                      >
                        <strong style="color: #fff"
                          >{{ Number(item.num).toLocaleString("en") }}
                          {{ $t("dashboardUser.list") }}
                        </strong>
                      </v-progress-linear>
                    </v-container>
                    <v-layout row wrap justify-center align-center>
                      <v-container>
                        <v-divider></v-divider>
                        <v-flex xs12 lg12>
                          <v-card
                            class="mx-auto justify-space-evenly"
                            elevation="0"
                            height="100%"
                          >
                            <v-card-title>
                              <v-avatar size="25" color="#077893" class="mr-2">
                                <v-icon small dark>mdi-vector-circle </v-icon>
                              </v-avatar>
                              <div class="font-weight-bold">
                                <span
                                  style="font-size: 18px"
                                  class="font-weight-bold"
                                >
                                  {{ $t("dashboard.logEmail") }}
                                </span>
                              </div>
                            </v-card-title>
                            <v-card-text class="text-center mt-3">
                              <v-layout
                                style="justify-content: space-evenly"
                                row
                                wrap
                                align-center
                              >
                                <v-flex
                                  color="#077893"
                                  v-for="item in LogSend"
                                  :key="item.title"
                                  xs12
                                  md5
                                  lg5
                                  class="text-left black--text d-flex align-center justify-space-between my-4"
                                  style="
                                    background: #dff7ff;
                                    border-radius: 2rem;
                                  "
                                >
                                  <div class="pl-2">{{ $t(item.title) }}</div>
                                  <!-- <b
                                    class="gray--text"
                                    style="font-size: 1.5rem"
                                    >{{ item.num }}</b
                                  > -->
                                  <v-avatar left color="#077893">
                                    <b
                                      style="font-size: 1.5rem; color: #dff7ff"
                                      >{{ item.num.toLocaleString("en") }}</b
                                    >
                                  </v-avatar>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-container>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 lg5></v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
import GeneralConsent from "../Dashboard/DashboardGeneralConsent.vue";
import GroupConsent from "../Dashboard/DashboardGroupConsent.vue";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: { GeneralConsent, GroupConsent, OverlaySearch },
  data() {
    return {
      loadingDownloadData: false,
      LoadCard: false,
      info: "",
      Consentitems: [],
      tab: null,
      Logsend: [],
      GeneralConsent: [],
      GroupConsent: [],
      SourceSystem: [],
      series: [],
      LogSend: [],
      items: [
        { text: "consentlist.generalconsent" },
        {
          text: "consentlist.groupconsent",
        },
      ],
      options: {
        chart: {
          id: "vuechart-example",
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
      },
      optionsEng: {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
      },
      NumMonth: { text: "ทั้งหมด", value: 0 },
      CountMonth: [
        { text: "ทั้งหมด", value: 0 },
        { text: "1เดือน", value: 1 },
        { text: "3เดือน", value: 3 },
        { text: "6เดือน", value: 6 },
        { text: "12เดือน", value: 12 },
      ],
      SliceCount: "",
      Sliceymth: "",
      Sliceymeng: "",
      chartOptionsDonut: {
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: false,
                total: {
                  showAlways: false,
                  show: false,
                  // label: this.$t("dashboard.count"),
                  label: this.$t("dashboard.count"),
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                  fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  fontSize: 20,
                  cssClass: "apexcharts-yaxis-label",
                },
              },
            },
          },
        },
        chart: {
          width: 50,
          type: "donut",
        },
        // colors: ["#4caf50", "#ff5252", "#fb8c00", "#9e9e9e"],
        colors: ["#077893", "#ff5252", "#0AADD6", "#043F4E"],
        dataLabels: {
          enabled: false,
        },
        labels: ["ยินยอม", "ปฏิเสธ"],
        fill: {
          type: "gradient",
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: false,
          theme: "dark",
        },
        responsive: [
          {
            breakpoint: 50,
          },
        ],
      },
      seriesDonutss: [32, 10, 24, 6],
      numtest: 74,
      Status: [],
      StatusAll: [],
      CountGeneral: [],
      CountGeneralAll: [],
      CountGeneralApprove: [],
      CountGeneralUnApprove: [],
      CountGeneralWait: [],
      CountGeneralExpire: [],
      CountGroup: [],
      CountGroupAll: [],
      CountGroupApprove: [],
      CountGroupUnApprove: [],
      CountGroupWait: [],
      CountGroupExpire: [],
      seriesDonut: [],
      seriesDonutFix: [],
      seriesDonutFixGeneral: [],
      seriesDonutFixGroup: [],
      StatusCountApprove: [],
      StatusCountUnApprove: [],
      StatusCountWait: [],
      StatusCountExpire: [],
      HeadAll: "ความยินยอมทั้งหมด",
      HeadGeneral: "ความยินยอมทั่วไป",
      HeadGroup: "ความยินยอมแบบกลุ่ม",
    };
  },
  methods: {
    async Fn_GetDashboard() {
      this.count = [];
      this.ymth = [];
      this.ymeng = [];
      this.ConsentAll = [];
      this.ConsentGeneral = [];
      this.ConsentGroup = [];
      // this.loadingDownloadData = true;
      this.LoadCard = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "dashbord/consent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          this.LoadCard = false;
          if (response.status === 200) {
            this.GetDashboard = response.data;
            this.Status = response.data.Status;
            this.StatusAll = response.data.Status.Count
            this.StatusCountApprove = this.Status.CountApprove;
            this.StatusCountUnApprove = this.Status.CountUnApprove;
            this.StatusCountWait = this.Status.CountWait
            this.StatusCountExpire = this.Status.CountExpire;
            this.SourceSystem = response.data.SourceSystem;
            this.CountGeneral = response.data.Send.CountGeneral;
            this.CountGeneralAll = this.CountGeneral.Count;
            this.CountGeneralApprove = this.CountGeneral.Approve;
            this.CountGeneralUnApprove = this.CountGeneral.UnApprove;
            this.CountGeneralWait = this.CountGeneral.Wait;
            this.CountGeneralExpire = this.CountGeneral.Expire;
            this.CountGroup = response.data.Send.CountGroup;
            this.CountGroupAll = this.CountGroup.Count;
            this.CountGroupApprove = this.CountGroup.Approve;
            this.CountGroupUnApprove = this.CountGroup.UnApprove;
            this.CountGroupWait = this.CountGroup.Wait;
            this.CountGroupExpire = this.CountGroup.Expire;
            this.graph = response.data.YearMonth;
            for (var i = 0; i < this.graph.length; i++) {
              this.ymth.push(this.graph[i].YearMonthTh);
              this.ymeng.push(this.graph[i].YearMonthEng);
              this.count.push(this.graph[i].Count);
            }
            this.SliceCount = this.count;
            this.Sliceymth = this.ymth;
            this.Sliceymeng = this.ymeng;
            (this.options = {
              plotOptions: {
                bar: {
                  distributed: true,
                  columnWidth: "50%",
                  distributed: true,
                  borderRadius: 5,
                  dataLabels: {
                    position: "top",
                    enabled: true,
                  },
                },
              },
              chart: {
                id: "vuechart-example",
                toolbar: {
                  show: false,
                },
              },
              xaxis: {
                categories: this.ymth,
                labels: {
                  show: true,
                  style: {
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                    fontSize: 9,
                  },
                },
              },
              yaxis: {
                labels: {
                  show: true,
                  style: {
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                    cssClass: "apexcharts-yaxis-label",
                  },
                  formatter: (val) => {
                    return val.toLocaleString("en-US");
                  },
                },
              },
              colors: [
                "#3B93A5",
                // "#F7B844",
                // "#ADD8C7",
                // "#EC3C65",
                // "#CDD7B6",
                // "#C1F666",
                // "#D43F97",
                // "#1E5D8C",
                // "#421243",
                // "#7F94B0",
                // "#EF6537",
                // "#C0ADDB",
              ],
              fill: {
                type: "gradient",
              },
              dataLabels: {
                enabled: true,
                offsetY: -30,
                style: {
                  colors: ["#077893"],
                  fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  cssClass: "apexcharts-yaxis-label",
                },
                formatter: function (val) {
                  return val.toLocaleString("en-US");
                },
              },
              legend: {
                show: false,
              },
              tooltip: {
                theme: "dark",
                style: {
                  fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                },
                x: {
                  show: true,
                },
                y: {
                  title: {
                    formatter: function (a, b, c) {
                      return "";
                    },
                  },
                },
              },
            }),
              (this.optionsEng = {
                plotOptions: {
                  bar: {
                    distributed: true,
                    columnWidth: "50%",
                    distributed: true,
                    borderRadius: 5,
                    dataLabels: {
                      position: "top",
                      enabled: true,
                    },
                  },
                },
                chart: {
                  id: "vuechart-example",
                  toolbar: {
                    show: false,
                  },
                },
                xaxis: {
                  categories: this.ymeng,
                  labels: {
                    show: true,
                    style: {
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                      fontWeight: 600,
                      fontSize: 9,
                    },
                  },
                },
                yaxis: {
                  labels: {
                    show: true,
                    style: {
                      fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                      fontWeight: 600,
                      cssClass: "apexcharts-yaxis-label",
                    },
                    formatter: (val) => {
                      return val.toLocaleString("en-US");
                    },
                  },
                },
                colors: [
                  "#3B93A5",
                  // "#F7B844",
                  // "#ADD8C7",
                  // "#EC3C65",
                  // "#CDD7B6",
                  // "#C1F666",
                  // "#D43F97",
                  // "#1E5D8C",
                  // "#421243",
                  // "#7F94B0",
                  // "#EF6537",
                  // "#C0ADDB",
                ],
                fill: {
                  type: "gradient",
                },
                dataLabels: {
                  enabled: true,
                  offsetY: -30,
                  style: {
                    colors: ["#077893"],
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                    fontWeight: 600,
                    cssClass: "apexcharts-yaxis-label",
                  },
                  formatter: function (val) {
                    return val.toLocaleString("en-US");
                  },
                },
                legend: {
                  show: false,
                },
                tooltip: {
                  theme: "dark",
                  style: {
                    fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                  },
                  x: {
                    show: true,
                  },
                  y: {
                    title: {
                      formatter: function (a, b, c) {
                        return "";
                      },
                    },
                  },
                },
              }),
              (this.series = [
                {
                  name: "",
                  data: this.count,
                },
              ]),
              (this.ConsentAll = response.data.Status);
            this.ConsentGeneral = response.data.Send.CountGeneral;
            this.ConsentGroup = response.data.Send.CountGroup;

            this.LogSend = response.data.MailServer;
            this.SourceSystem = response.data.SourceSystem;

            this.Consentitems = [
              {
                title: "dashboard.total",
                all: this.ConsentAll.Count,
                approve: this.ConsentAll.CountApprove,
                unapprove: this.ConsentAll.CountUnApprove,
                wait: this.ConsentAll.CountWait,
                expire: this.ConsentAll.CountExpire,
                color: "light-blue lighten-3",
                icon: "mdi-tune-variant",
              },
              {
                title: "consentlist.generalconsent",
                all: this.ConsentGeneral.Count,
                approve: this.ConsentGeneral.Approve,
                unapprove: this.ConsentGeneral.UnApprove,
                wait: this.ConsentGeneral.Wait,
                expire: this.ConsentGeneral.Expire,
                color: "amber lighten-3",
                icon: "mdi-vector-line",
              },
              {
                title: "consentlist.groupconsent",
                all: this.ConsentGroup.Count,
                approve: this.ConsentGroup.Approve,
                unapprove: this.ConsentGroup.UnApprove,
                wait: this.ConsentGroup.Wait,
                expire: this.ConsentGroup.Expire,
                color: "teal lighten-3",
                icon: "mdi-vector-square",
              },
            ];
            this.LogSend = [
              {
                title: "dashboard.sendEmail",
                num: this.LogSend.SendMail,
                icon: "mdi-vector-ellipse",
              },
              {
                title: "dashboard.sendConsent",
                num: this.LogSend.Consent.Count,
                icon: "mdi-vector-ellipse",
              },
              {
                title: "dashboard.testEmail",
                num: this.LogSend.TestSendMail,
                icon: "mdi-vector-circle",
              },
              {
                title: "dashboard.alert",
                num: this.LogSend.Alert,
                icon: "mdi-vector-circle-variant",
              },
            ];

            this.SourceSystem = [
              {
                title: "API",
                num: this.SourceSystem.API,
                icon: "mdi-api",
              },
              {
                title: "PDF",
                num: this.SourceSystem.PDF,
                icon: "mdi-file-pdf-box",
              },
              {
                title: "Email",
                num: this.SourceSystem.Email,
                icon: "mdi-email",
              },
              {
                title: "Onechat",
                num: this.SourceSystem.OneChat,
                icon: "mdi-message-text",
              },
              {
                title: "Webscript",
                num: this.SourceSystem.Webscript,
                icon: "mdi-script",
              },
            ];
            this.seriesDonutFix = [
              this.ConsentAll.CountApprove,
              this.ConsentAll.CountUnApprove,
              this.ConsentAll.CountWait,
              this.ConsentAll.CountExpire,
            ];
            this.seriesDonutFixGeneral = [
              this.ConsentGeneral.Approve,
              this.ConsentGeneral.UnApprove,
              this.ConsentGeneral.Wait,
              this.ConsentGeneral.Expire,
            ];
            this.seriesDonutFixGroup = [
              this.ConsentGroup.Approve,
              this.ConsentGroup.UnApprove,
              this.ConsentGroup.Wait,
              this.ConsentGroup.Expire,
            ];
            // for (var i = 0; i < this.Consentitems.length; i++) {
            //   this.seriesDonut.push(
            //     this.Consentitems[i].approve,
            //     this.Consentitems[i].unapprove
            //   );
            // }
            // for (let i = 0; i < this.seriesDonut.length; i += 2) {
            //   this.seriesDonutFix.push(
            //     this.seriesDonut.slice(i, i + 2).map((value) => parseInt(value))
            //   );
            // }
            // this.seriesDonutFix = this.seriesDonutFix.flat();

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            this.$router.push("/profile");
            // Toast.fire({
            //   icon: "error",
            //   title: error.response.data.ErrorMessage,
            // });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            // Toast.fire({
            //   icon: "error",
            //   title:  error.message || error,
            // });
          }
        });
    },
    Fn_SelectCountMonth(val) {
      if (val == 0) {
        this.count = [];
        this.ymth = [];
        this.ymeng = [];
        this.Fn_GetDashboard();
      }
      if (val == 1) {
        if (this.SliceCount.length < 1) {
          this.count = this.SliceCount.slice(0);
          this.ymth = this.Sliceymth.slice(0);
          this.ymeng = this.Sliceymeng.slice(0);
          this.Fn_SetGraph();
        } else {
          this.count = this.SliceCount.slice(-1);
          this.ymth = this.Sliceymth.slice(-1);
          this.ymeng = this.Sliceymeng.slice(-1);
          this.Fn_SetGraph();
        }
      }
      if (val == 3) {
        if (this.SliceCount.length < 3) {
          this.count = this.SliceCount.slice(0);
          this.ymth = this.Sliceymth.slice(0);
          this.ymeng = this.Sliceymeng.slice(0);
          this.Fn_SetGraph();
        } else {
          this.count = this.SliceCount.slice(-3);
          this.ymth = this.Sliceymth.slice(-3);
          this.ymeng = this.Sliceymeng.slice(-3);
          this.Fn_SetGraph();
        }
      }
      if (val == 6) {
        if (this.SliceCount.length < 6) {
          this.count = this.SliceCount.slice(0);
          this.ymth = this.Sliceymth.slice(0);
          this.ymeng = this.Sliceymeng.slice(0);
          this.Fn_SetGraph();
        } else {
          this.count = this.SliceCount.slice(-6);
          this.ymth = this.Sliceymth.slice(-6);
          this.ymeng = this.Sliceymeng.slice(-6);
          this.Fn_SetGraph();
        }
      }
      if (val == 12) {
        if (this.SliceCount.length < 12) {
          this.count = this.SliceCount.slice(0);
          this.ymth = this.Sliceymth.slice(0);
          this.ymeng = this.Sliceymeng.slice(0);
          this.Fn_SetGraph();
        } else {
          this.count = this.SliceCount.slice(-12);
          this.ymth = this.Sliceymth.slice(-12);
          this.ymeng = this.Sliceymeng.slice(-12);
          this.Fn_SetGraph();
        }
      }
    },
    Fn_SetGraph() {
      (this.options = {
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "50%",
            distributed: true,
            dataLabels: {
              position: "top",
              enabled: true,
            },
          },
        },
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: this.ymth,
          labels: {
            show: true,
            style: {
              fontFamily: "Prompt, Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-label",
            },
          },
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              fontFamily: "Prompt, Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-label",
            },
            formatter: (val) => {
              return val.toLocaleString("en-US");
            },
          },
        },
        colors: [
          "#3B93A5",
          // "#F7B844",
          // "#ADD8C7",
          // "#EC3C65",
          // "#CDD7B6",
          // "#C1F666",
          // "#D43F97",
          // "#1E5D8C",
          // "#421243",
          // "#7F94B0",
          // "#EF6537",
          // "#C0ADDB",
        ],
        fill: {
          type: "gradient",
        },
        dataLabels: {
          enabled: true,
          offsetY: -30,
          style: {
            colors: ["#077893"],
            fontFamily: "Prompt, Helvetica, Arial, sans-serif",
            fontWeight: 600,
            cssClass: "apexcharts-yaxis-label",
          },
          formatter: function (val) {
            return val.toLocaleString("en-US");
          },
        },
      }),
        (this.optionsEng = {
          plotOptions: {
            bar: {
              distributed: true,
              columnWidth: "50%",
              distributed: true,
              dataLabels: {
                position: "top",
                enabled: true,
              },
            },
          },
          chart: {
            id: "vuechart-example",
            toolbar: {
              show: false,
            },
          },
          xaxis: {
            categories: this.ymeng,
            labels: {
              show: true,
              style: {
                fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                fontWeight: 600,
                cssClass: "apexcharts-yaxis-label",
              },
            },
          },
          yaxis: {
            labels: {
              show: true,
              style: {
                fontFamily: "Prompt, Helvetica, Arial, sans-serif",
                fontWeight: 600,
                cssClass: "apexcharts-yaxis-label",
              },
              formatter: (val) => {
                return val.toLocaleString("en-US");
              },
            },
          },
          colors: [
            "#3B93A5",
            // "#F7B844",
            // "#ADD8C7",
            // "#EC3C65",
            // "#CDD7B6",
            // "#C1F666",
            // "#D43F97",
            // "#1E5D8C",
            // "#421243",
            // "#7F94B0",
            // "#EF6537",
            // "#C0ADDB",
          ],
          fill: {
            type: "gradient",
          },
          dataLabels: {
            enabled: true,
            offsetY: -30,
            style: {
              colors: ["#077893"],
              fontFamily: "Prompt, Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-label",
            },
            formatter: function (val) {
              return val.toLocaleString("en-US");
            },
          },
        }),
        (this.series = [
          {
            name: "",
            data: this.count,
          },
        ]);
    },
    async GetDetailDashbord(val, count) {
      this.$cookies.set("DetailDashbord", val);
      this.$cookies.set("CountDashbord", count);
      this.$router.push({ path: "/consent-detail-dashboard" });
    },
    async DetailSourceSystem(val, count) {
      this.$cookies.set("DetailDashbord", val);
      this.$cookies.set("CountDashbord", count);
      this.$router.push({ path: "/consent-detail-dashboard" });
    },
  },
  computed: {
    ...mapGetters(["Profile"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _SelectBusinessId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _SelectBusinessNameTH: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    flatData() {
      return this.data.flat();
    },
  },
  mounted() {
    this.loadingDownloadData = true;
    this.count = [];
    this.ymth = [];
    this.ymeng = [];
    this.ConsentAll = [];
    this.ConsentGeneral = [];
    this.ConsentGroup = [];
    this.Fn_GetDashboard();
    this.Fn_SelectCountMonth();
  },
  created() {
    // setInterval(this.Fn_GetDashboard, 5000);
  },
  watch: {
    // _SelectBusinessId(val) {
    //   if (val) {
    //     this.graph;
    //   }
    // },
  },
};
</script>

<style>
div#apexchartsvuechart-example {
  display: block;
  margin: auto;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
@media screen and (max-width: 1263px) {
  .flexresponsive {
    display: none !important;
  }
}

.border {
  border-radius: 10px;
}

.v-card__text.setpad {
  padding: 0.5rem !important;
}

.hover {
  transition: 0.3s;
}

.hover:hover {
  background-color: #ddf7ff;
}

.custom-donut-label {
  font-size: 24px;
  font-weight: bold;
  fill: red;
}

#customers {
  border-collapse: collapse;
  width: 100%;
  background-color: #fff;
}

/* #customers td,
#customers th {
  border: 1px solid gray !important;
  padding: 8px;
} */

#customers th {
  text-align: center !important;
}

#customers tr {
  background-color: #dff7ff;
  border-radius: 1rem;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #077893;
  color: white;
}
</style>

<style>
.apexcharts-legend.apexcharts-align-center.apx-legend-position-right {
  display: none !important;
}

.v-progress-linear.v-progress-linear--visible.theme--light {
  border-radius: 1rem;
}

div#apexcharts3wmtrh7hj {
  display: block !important;
  margin: auto !important;
}

.v-avatar.v-avatar--left {
  background: rgb(7, 120, 147);
  background: radial-gradient(
    circle,
    rgba(7, 120, 147, 1) 30%,
    rgba(223, 247, 255, 1) 100%
  );
}

/* .apexcharts-gridline,
.apexcharts-annotation-rect,
.apexcharts-xaxis-annotation-label,
.apexcharts-yaxis-annotation-label,
.apexcharts-point-annotation-label,
.apexcharts-tooltip .apexcharts-marker,
.apexcharts-area-series .apexcharts-area,
.apexcharts-line,
.apexcharts-zoom-rect,
.apexcharts-toolbar svg,
.apexcharts-area-series
  .apexcharts-series-markers
  .apexcharts-marker.no-pointer-events,
.apexcharts-line-series
  .apexcharts-series-markers
  .apexcharts-marker.no-pointer-events,
.apexcharts-radar-series path,
.apexcharts-radar-series polygon {
  display: none !important;
} */
</style>
